export interface DispositivoVideoCaptura {
  deviceId: string;
  label:    string;
}

export const HDMI_DEVICE_KEY = 'ds:hdmi_device_id';

export interface HdmiEstadoBroadcast {
  dispositivos:   DispositivoVideoCaptura[];
  deviceIdAtivo: string;
}

export function lerHdmiDeviceIdSalvo(): string {
  try { return localStorage.getItem(HDMI_DEVICE_KEY) ?? ''; } catch { return ''; }
}

export function salvarHdmiDeviceId(id: string): void {
  try { localStorage.setItem(HDMI_DEVICE_KEY, id); } catch { /* ignore */ }
}

export function limparHdmiDeviceIdSalvo(): void {
  try { localStorage.removeItem(HDMI_DEVICE_KEY); } catch { /* ignore */ }
}

/** Lista placas HDMI / câmeras USB via enumerateDevices (requer permissão de vídeo para labels). */
export async function enumerarDispositivosVideo(): Promise<DispositivoVideoCaptura[]> {
  const mediaDevices = navigator.mediaDevices;
  if (!mediaDevices?.enumerateDevices) return [];

  let streamTemp: MediaStream | null = null;
  try {
    streamTemp = await mediaDevices.getUserMedia({ video: true, audio: false });
  } catch { /* sem permissão — labels podem ficar vazios */ }

  try {
    const todos = await mediaDevices.enumerateDevices();
    return todos
      .filter(d => d.kind === 'videoinput')
      .map((d, i) => ({
        deviceId: d.deviceId,
        label:    d.label || `Entrada ${i + 1}`,
      }));
  } finally {
    streamTemp?.getTracks().forEach(t => t.stop());
  }
}

export function resolverDeviceIdInicial(
  dispositivos: DispositivoVideoCaptura[],
  salvo: string,
): { deviceId: string; abrirSeletor: boolean } {
  if (dispositivos.length === 0) return { deviceId: '', abrirSeletor: false };

  if (salvo && dispositivos.some(d => d.deviceId === salvo)) {
    return { deviceId: salvo, abrirSeletor: false };
  }
  if (dispositivos.length === 1) {
    return { deviceId: dispositivos[0].deviceId, abrirSeletor: false };
  }
  // Múltiplas entradas sem preferência salva — Controle Remoto escolhe; TV usa a primeira até lá.
  return { deviceId: dispositivos[0].deviceId, abrirSeletor: false };
}
